import React, { useEffect } from 'react'
import scriptLoader from 'react-async-script-loader'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { ArticleLarge } from '../components/common/Layout'
import { SpinnerCard } from '../components/common/Layout'
import { MAPS_SCRIPT_URL } from '../components/location-search/LocationSearchBox'
import SelectLocation, { RequestFoodsbyLink } from '../components/location-search/SelectLocation'
import { search, selectedKiosk, update } from '../redux/modules/locationSearch'
import { clearSearch, loadLocationsFromAddressIdStart } from '../redux/modules/locationSearch'
import { getAddressQueryStringParams, getLocationIdParam } from '../redux/modules/selectors'
import { locationRoute } from '../routes/routes'
import { formatAddress, formatUrl } from '../util/formatUtils'
import { pushAnalyticsEvent } from '../util/gtmUtils'
import { hasAValueDefined } from '../util/keys'

export const PageSelectLocation = ({
  address,
  completeAccountToken,
  error,
  history,
  isScriptLoadSucceed,
  isScriptLoaded,
  lat,
  lng,
  loading,
  locations,
  redirected,
  search,
}) => {
  useEffect(() => {
    if (address && redirected) {
      if (isScriptLoaded && isScriptLoadSucceed) {
        search(address)
      }
    }
  }, [address, isScriptLoadSucceed, isScriptLoaded, redirected, search])

  const goToLocation = id => {
    pushAnalyticsEvent('Registration Flow', 'Select Nearby Kiosk', undefined, id)
    if (completeAccountToken) {
      window.location.href = `/complete-account/${completeAccountToken}/?newLocationId=${id}`
    } else {
      clearSearch()
      selectedKiosk()
      history.push(
        formatUrl(locationRoute.path, {
          locationId: id,
        }),
      )
    }
  }

  return (
    <ArticleLarge>
      <SpinnerCard spinnerActive={!isScriptLoaded}>
        {isScriptLoaded && isScriptLoadSucceed && (
          <SelectLocation
            address={address}
            goToLocation={goToLocation}
            lat={address ? lat : undefined}
            lng={address ? lng : undefined}
            locations={locations}
            search={search}
            showError={error}
            submitting={loading}
            updateAddress={update}
          />
        )}
      </SpinnerCard>
      <RequestFoodsbyLink />
    </ArticleLarge>
  )
}

const mapStateToProps = (state, ownProps) => {
  const {
    address,
    completeAccountToken,
    error,
    lat,
    lng,
    loading,
    locations,
  } = state.locationSearch
  const queryParams = getAddressQueryStringParams(state.router, ownProps)

  return {
    address: address || formatAddress(queryParams),
    completeAccountToken,
    error,
    id: getLocationIdParam(state, ownProps),
    lat: lat || queryParams.lat,
    lng: lng || queryParams.lng,
    loading,
    locations,
    redirected: hasAValueDefined(queryParams),
  }
}

const mapDispatchToProps = {
  clearSearch,
  loadLocationsFromAddressIdStart,
  search,
  selectedKiosk,
  update,
}

export default scriptLoader(MAPS_SCRIPT_URL)(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(PageSelectLocation)),
)
